import axios from "axios";
import { backUrl } from "../utils/backURL";

const API_URL = backUrl;

/**
 * Get business dashboard data for public access
 * @param {string} businessId - ID of the business
 * @param {number} dashboardIndex - Index of the dashboard (0-based)
 * @returns {Promise<Object>} - Response with business name, logo, dashboard title and URL
 */
export const getPublicDashboardData = async (businessId, dashboardIndex) => {
  try {
    // Get business information and dashboard data in one call
    const response = await axios.get(`${API_URL}/mantisBusiness/${businessId}/public-dashboard/${dashboardIndex}`);
    return {
      success: true,
      data: response.data.data || response.data
    };
  } catch (error) {
    console.error("Error getting public dashboard data:", error);
    return {
      success: false,
      error: error.response?.data?.message || "Error al obtener datos del dashboard",
      status: error.response?.status
    };
  }
};
